module.exports = __webpack_public_path__ + "3625662aa51eabf337ec00badc70f577.svg";